module.exports = __webpack_public_path__ + "static/img/banwagong.a689a21.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/life/banwagong.jpeg
// module id = s5gR
// module chunks = 0